import type { Features } from "@/types/features.types";
import { FEATURES } from "@/constants/features";

const environment = import.meta.env.MODE;

const defaultFeatures: Features = Object.values(FEATURES).reduce<Features>(
	(accumulator, feature) => {
		const environments =
			"environments" in feature
				? (feature.environments as ReadonlyArray<string>)
				: null;
		accumulator[feature.key] =
			!environments || environments.includes(environment);
		return accumulator;
	},
	{} as Features
);

export const featuresService = {
	getFeatures(): Promise<Features> {
		return Promise.resolve(defaultFeatures);
	},
};
